import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import "./BillingSystem.css";

export default function Navigation({ role }) {
  const navigate = useNavigate();
  const [open, setOpen] = useState(false);

  // Hide sidebar if user role is not allowed
  if (
    role !== "production" &&
    role !== "stock manager" &&
    role !== "salesman" &&
    role !== "special manager" &&
    role !== "hr"
  ) {
    return null;
  }

  return (
    <>
      {/* ☰ Toggle Button */}
      {!open && (
        <button className="menu-button" onClick={() => setOpen(true)}>
          ☰
        </button>
      )}

      {/* 📋 Sidebar */}
      <div className={`sidebar ${open ? "open" : ""}`}>
        <button className="close-btn" onClick={() => setOpen(false)}>
          ×
        </button>

        <h3>📋 Menu</h3>

        <ul>
          {/* 📦 STOCK MANAGER */}
          {role === "stock manager" && (
            <>
              <li>
                <button onClick={() => { navigate("/raw-stock"); setOpen(false); }}>
                  📦 Raw Stock
                </button>
              </li>
              <li>
                <button onClick={() => { navigate("/scrap"); setOpen(false); }}>
                  🗑️ Scrap
                </button>
              </li>
            </>
          )}

          {/* 🏭 PRODUCTION */}
          {role === "production" && (
            <>
              <li>
                <button onClick={() => { navigate("/staff"); setOpen(false); }}>
                  📄 Token History
                </button>
              </li>

              <li>
                <button onClick={() => { navigate("/production"); setOpen(false); }}>
                  🏭 Production
                </button>
              </li>

              <li>
                <button onClick={() => { navigate("/raw-stock"); setOpen(false); }}>
                  📦 Raw Stock
                </button>
              </li>

              <li>
                <button onClick={() => { navigate("/scrap"); setOpen(false); }}>
                  🗑️ Scrap
                </button>
              </li>

              <li>
                <button onClick={() => { navigate("/opening-stock"); setOpen(false); }}>
                  📥 Opening Stock
                </button>
              </li>

              <li>
                <button onClick={() => { navigate("/closing-stock"); setOpen(false); }}>
                  📤 Closing Stock
                </button>
              </li>
            </>
          )}

          {/* 🧑‍💼 SALESMAN */}
          {role === "salesman" && (
            <>
              <li>
                <button onClick={() => { navigate("/report"); setOpen(false); }}>
                  📊 Salesman Report
                </button>
              </li>

              <li>
                <button onClick={() => { navigate("/my-sales"); setOpen(false); }}>
                  🛒 My Sales
                </button>
              </li>
            </>
          )}

          {/* 🧑‍💼 HR */}
          {role === "hr" && (
            <>
              
          <li>
            <button onClick={() => { navigate("/attendance"); setOpen(false); }}>
              🕒 Auto Attendance
            </button>
          </li>
           <li>
            <button onClick={() => { navigate("/manual-entry"); setOpen(false); }}>
              📝 Manual Attendance
            </button>
          </li>

          <li>
            <button onClick={() => { navigate("/attendance-report"); setOpen(false); }}>
              📊 Attendance Report
            </button>
          </li>

          <li>
            <button onClick={() => { navigate("/add-employee"); setOpen(false); }}>
              ➕ Add Employee
            </button>
          </li>

          <li>
            <button onClick={() => { navigate("/employees"); setOpen(false); }}>
              👥 Employees List
            </button>
          </li>
            </>
          )}

          {/* ⭐ SPECIAL MANAGER */}
          {role === "special manager" && (
            <>
              <li>
                <button onClick={() => { navigate("/bank"); setOpen(false); }}>
                  🏦 Bank
                </button>
              </li>

              <li>
                <button onClick={() => { navigate("/expenses"); setOpen(false); }}>
                  💸 Expenses
                </button>
              </li>

              <li>
                <button onClick={() => { navigate("/bottlersSP"); setOpen(false); }}>
                  💧 Bottlers History
                </button>
              </li>

              <li>
                <button onClick={() => { navigate("/enterprisesSP"); setOpen(false); }}>
                  🏭 Enterprises History
                </button>
              </li>
            </>
          )}
        </ul>
      </div>
    </>
  );
}